<template>
  <div class="text-sm mx-2">
    <div class="text-center text-2xl">{{ $t("logout") }}</div>
    <div class="ml-4 mt-4">{{ $t("question_logout") }}</div>
    <div class="flex flex-initial mt-4 lg:mt-6">
      <button
        class="w-1/2 py-2 border-2 bg-gray-200 hover:bg-gray-500"
        @click="$emit('close')"
      >
        {{ $t("cancel") }}
      </button>
      <button
        class="py-2 w-1/2 border-2 bg-red-400 hover:bg-red-500"
        @click="logOut()"
      >
        {{ $t("exit") }}
      </button>
    </div>
  </div>
</template>
<script>
/**
 * Componente modal de logout
 * --------------------------------------------
 *
 * Este componente para confirmar si quieres hacer logout. Cuando confirmas, se borra el sessionStorage,se destruye el token y te redirige a la vista de login.
 * Aparte de confirmar también puedes cancelar la acción. 
 *
 */
import { logoutUser } from "@/utils/AuthService.js";

export default {
  methods: {
    logOut() {
      this.$emit("close");
      logoutUser();
      this.$router.push({ path: "/login" });
    },
    cancelLogout() {
      this.$modal.hide("dialog");
    }
  }
};
</script>
<style>

</style>